<template>
  <div class="row">
    <div class="input-field col s12">
      <input id="mail" type="email" v-model="mail" autocomplete="off">
      <label for="mail" v-bind:class="{ active: mail }">Adresse mail (facultatif)</label>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    mail: {
      get() {
        return this.$store.state.mail;
      },
      set(value) {
        this.$store.commit("updateMail", value);
      }
    }
  }
};
</script>